import {
  type PermitVersion,
  type PermitVersionRequest,
  type ReportSchedule,
} from "@/views/permitVersion/permitVersion";
import {
  fillLookupValuesByPropertyNames,
  getLookupDescription,
  getLookupMetadata,
} from "@modernary/mui/components/lookup";

// const { permitTypes } = enums;

export default {
  addAuthRequestFields,
  getInitialData,
  // reportSchedulesResponseAdapter,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: PermitVersion) {
  entity._authRequestFields = ["id", "statusMurn", "terminationDate"] as (keyof PermitVersion)[];
  return entity;
}

function getInitialData() {
  const result = {} as PermitVersion;
  return addAuthRequestFields(result);
}

// async function reportSchedulesResponseAdapter(response: { data: ReportSchedule }) {
//   await fillLookupValuesByPropertyNames(response.data, ["reportTypeMurn", "frequencyMurn"]);

//   return response.data;
// }

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: PermitVersion }) {
  response.data.hasExpiration = Boolean((await getLookupMetadata(response.data.permit?.typeMurn))?.hasExpiration);
  response.data.hasRenewal = Boolean((await getLookupMetadata(response.data.permit?.typeMurn))?.hasRenewal);

  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: PermitVersion }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: PermitVersionRequest) {
  delete data._authRequestFields;
  //@ts-ignore //TODO:TS
  delete data.annotations;
  delete data.facilitySite;
  delete data.permit;

  if (!data.issuedDate) data.issuedDate = null;
  if (!data.effectiveDate) data.effectiveDate = null;
  if (!data.expirationDate) data.expirationDate = null;

  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: any) {} //TODO:TS

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {} //TODO:TS
